export const SET_REMARKS = 'SET_REMARKS';
export const RESET_REMARKS = 'RESET_REMARKS';

export type SetRemarksAction = {
	type: typeof SET_REMARKS;
	payload: string;
};

export type ResetRemarksAction = {
	type: typeof RESET_REMARKS;
};

export type RemarksActionTypes = ResetRemarksAction | SetRemarksAction;
